
export const department_topics = (state) => {
  return state.topics.filter( t => t.department_id === state.department_id )
              .filter( t => t.active )
              .sort( (a,b) => a.sort - b.sort )
}
export const selected_topic = (state) => (topic_id) => {
  state.current_topic_id = topic_id
  return state.topics.find( t => t.id === topic_id )
}
export const selected_subject = (state) => (subject_id) => {
  let s = state.subjects.find( t => t.id === subject_id )
  state.current_topic_id = s.topic_id
  state.current_subject_id = subject_id
  return s
}
export const topic_subjects = (state) => (topic_id) => {
  return state.subjects.filter( s => s.topic_id === topic_id )
              .filter( s => s.active )
              .sort( (a,b) => a.sort - b.sort )
}
export const subject_blocks = (state) => (subject_id) => {
  return state.blocks.filter( b => b.subject_id === subject_id )
              .filter( b => b.parent_id === null )
              .filter( b => b.active )
              .sort( (a,b) => a.sort - b.sort )
}
export const sub_blocks = (state) => (parent_id) => {
  return state.blocks.filter( b => b.parent_id === parent_id )
              .filter( b => b.active )
              .sort( (a,b) => a.sort - b.sort )
}

export const filtered_quiz_blocks = ( state ) => {
  return state.blocks.filter( b => b.type_of_block == 'quiz' )
}

export const filtered_quiz_result = (state) => ( subject_id ) => {
  return state.quiz_blocks_status.filter( q => q.subject_id === subject_id )
}

export const current_quiz_blocks_status = ( state ) => ( block_id ) => {
  return state.quiz_blocks_status.find( b => b.id == block_id )
}

export const subject_quiz_blocks_status = ( state ) => ( subject_id ) => {
  return state.quiz_blocks_status.filter( b => b.subject_id == subject_id )
}

export const topic_quiz_blocks_status = ( state ) => ( topic_id ) => {
  return state.quiz_blocks_status.filter( b => b.topic_id == topic_id )
}

export const calc_quiz_result = () => ( quizes ) => {
  // console.log( 'in calc_quiz_result param', quizes)
  if( ! quizes || quizes.length <= 0 ) { return [ 0.0, 0.0 ] }
  let p = 0.0
  let m  = 0.0
  let done = 0
  Object.entries(quizes).forEach( b => {
    // console.log( 'loop', b )
    p += parseFloat( b[1].reached_points )
    m += parseFloat( b[1].max_points )
    if( b[1].done ) done += 1
  })
  // console.log( 'result', p, m, Math.round( ( p / m ) * 100 ), quizes.length )
  return {
    quiz_length: quizes.length,
    done: done,
    result: Math.round( ( p / m ) * 100 )
  }
}

export const calc_subject_quiz_result = ( state, getters ) => ( subject_id ) => {
  const quizes = getters.subject_quiz_blocks_status( subject_id )
                     // .filter( q => q.done )
  // console.log( 'calc_subject_quiz_result found', quizes )
  let x = getters.calc_quiz_result( quizes )
  // console.log( x )
  return x
}

export const calc_topic_quiz_result = ( state, getters ) => ( topic_id ) => {
  const quizes = getters.topic_quiz_blocks_status( topic_id )
                     // .filter( q => q.done )
  let x = getters.calc_quiz_result( quizes )
  // console.log( 'calc_topic_quiz_result', x )
  return x
}
